import React from 'react';
import { connect } from 'react-redux';

import { answerQuestion } from '../../../../../_actions/questionnaire.actions';
import PainScale from './PainScale';

const Integer = ({ question, dispatch }) => {
  const itemControl = question.extension.find((extension) => {
    return extension.url === 'http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl';
  });

  return <>
    <h6 className="card-title">{question.linkId}. {question.text || 'Enter your question.'}</h6>

    {!itemControl &&
      <input
        onChange={(e) => {
          dispatch(answerQuestion(question, e.target.value))
        }} type="number" className="form-control" />
    }

    {itemControl && itemControl.valueCodeableConcept.coding[0].code === 'pain-scale' &&
      <PainScale question={question} dispatch={(integer) => {
        dispatch(answerQuestion(question, integer))
      }} />
    }
  </>;
}

export default connect()(Integer);